import React from "react";
import {
  FieldWrapper,
  FilterSelect,
  FilterSortGroup,
  CompactDateInput,
} from "./jobsFilterUtils";

export const QUEUE_SORT_OPTIONS = [
  { value: "create_date", label: "Date" },
  { value: "message_name", label: "Message" },
];

export const QUEUE_STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "S", label: "Sent" },
  { value: "PS", label: "Partially Sent" },
  { value: "ING", label: "Sending" },
  { value: "Q", label: "Queued" },
  { value: "C", label: "Canceled" },
  { value: "I", label: "Invalid Recipients" },
  { value: "F", label: "Failed" },
];

export function AdminMessagesQueueFilterFields({
  focusedFieldId,
  onFocusClear,
  queueFilter,
  setQueueFilter,
  mqMessageType,
  setMqMessageType,
  mqMessageTypeOptions = [],
  mqFromDate,
  setMqFromDate,
  mqToDate,
  setMqToDate,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
}) {
  const messageTypeOptions = mqMessageTypeOptions.map((type) => ({
    value: type === "All" ? "all" : type,
    label: type,
  }));

  return (
    <>
      <FieldWrapper
        fieldId="queueFilter"
        label="Status"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="admin-messages-queue-status"
          value={queueFilter}
          onChange={setQueueFilter}
          options={QUEUE_STATUS_OPTIONS}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="mqMessageType"
        label="Message Type"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="admin-messages-queue-type"
          value={mqMessageType}
          onChange={setMqMessageType}
          options={messageTypeOptions}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="mqFromDate"
        label="From"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <CompactDateInput
          id="admin-messages-queue-from"
          value={mqFromDate}
          onChange={setMqFromDate}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="mqToDate"
        label="To"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <CompactDateInput
          id="admin-messages-queue-to"
          value={mqToDate}
          onChange={setMqToDate}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="admin-messages-queue-sort"
          sortBy={sortField}
          sortOrder={sortOrder}
          onSortByChange={setSortField}
          onSortOrderChange={setSortOrder}
          sortOptions={QUEUE_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAdminMessagesQueueFilterChips({
  queueFilter,
  mqMessageType,
  mqFromDate,
  mqToDate,
  sortOrder,
}) {
  const chips = [];

  if (queueFilter && queueFilter !== "all") {
    const label = QUEUE_STATUS_OPTIONS.find((opt) => opt.value === queueFilter)?.label || queueFilter;
    chips.push({
      id: "queueFilter",
      key: "queueFilter",
      fieldId: "queueFilter",
      label: `Status: ${label}`,
    });
  }

  if (mqMessageType && mqMessageType !== "all") {
    chips.push({
      id: "mqMessageType",
      key: "mqMessageType",
      fieldId: "mqMessageType",
      label: `Message Type: ${mqMessageType}`,
    });
  }

  if (mqFromDate) {
    chips.push({
      id: "mqFromDate",
      key: "mqFromDate",
      fieldId: "mqFromDate",
      label: `From: ${mqFromDate}`,
    });
  }

  if (mqToDate) {
    chips.push({
      id: "mqToDate",
      key: "mqToDate",
      fieldId: "mqToDate",
      label: `To: ${mqToDate}`,
    });
  }

  if (sortOrder !== "desc") {
    chips.push({
      id: "sortOrder",
      key: "sortOrder",
      fieldId: "sort",
      label: `Direction: ${sortOrder === "asc" ? "Ascending" : "Descending"}`,
    });
  }

  return chips;
}
